const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "/api";

function buildUrl(path, params) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const isAbsoluteBase =
    API_BASE_URL.startsWith("http://") || API_BASE_URL.startsWith("https://");
  const basePath = API_BASE_URL.endsWith("/")
    ? API_BASE_URL.slice(0, -1)
    : API_BASE_URL;
  const url = isAbsoluteBase
    ? new URL(`${basePath}${normalizedPath}`)
    : new URL(`${basePath}${normalizedPath}`, window.location.origin);

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") {
        return;
      }
      url.searchParams.set(key, String(value));
    });
  }

  if (isAbsoluteBase) {
    return url.toString();
  }

  return `${basePath}${normalizedPath}${url.search}`;
}

async function request(path, options = {}) {
  const {
    method = "GET",
    params,
    data,
    headers,
    ...restOptions
  } = options;

  const response = await fetch(buildUrl(path, params), {
    method,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    body: data !== undefined ? JSON.stringify(data) : undefined,
    ...restOptions,
  });

  const result = await response.json().catch(() => ({}));
  const message = result?.message || result?.msg || "请求失败";

  if (!response.ok) {
    throw new Error(message);
  }

  if (result?.code !== undefined && result.code !== 0 && result.code !== 200) {
    throw new Error(message);
  }

  return {
    ...result,
    message,
  };
}

export async function get(path, params, options) {
  const response = await request(path, {
    method: "GET",
    params,
    ...options,
  });
  return response.data;
}

export async function post(path, data, options) {
  const response = await request(path, {
    method: "POST",
    data,
    ...options,
  });
  return {
    data: response.data,
    message: response.message,
  };
}

export { API_BASE_URL };
